<div class="wrapper">
  <div class="content" [ngClass]="{'reduce-content-spacing aem-style' : isAEMEnvironment}">
    <router-outlet #o="outlet"></router-outlet>
    <fal-legal-disclaimer [legalDisclaimerDescription]="legalDisclaimerDescription"></fal-legal-disclaimer>
  </div>
</div>
